import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
  selectedTask: null,
  showConfirmationModal: false,
  selectedTasksList: [],
  selectedTaskToView: null,
  viewTask: false,

  // break task flags
  showBreakTaskModal: false,
  breakTaskEmployee: null,
  selectedBreakTask: null,

  // adhoc task flags
  showAdhocTaskModal: false,
  adhocTaskEmployee: null,
  selectedAdhocTask: null,

  selectedFlightToView: null,

  selectedMultiplePAXTask: [],
  selectedMultiplePAXTaskError: null,

  showEditTaskModal: false,
  editModalType: "BOOKING"

};

const selectedTaskSlice = createSlice({
  name: "selectedTask",
  initialState,
  reducers: {
    reset: (state) => {
      state.selectedTask = null;
      state.showConfirmationModal = false;
      state.selectedTaskToView = null;
      state.selectedMultiplePAXTask = [];
      state.selectedMultiplePAXTaskError = null;
    },
    resetSelectedTasksList: (state) => {
      state.selectedTasksList = [];
    },
    setSelectedTask: (state, action) => {
      state.selectedTask = action.payload;
    },
    setShowConfirmationModal: (state, action) => {
      state.showConfirmationModal = action.payload;
    },
    setSelectedTaskList: (state, action) => {
      state.selectedTasksList = action.payload;
    },
    setSelectedTaskToView: (state, action) => {
      state.selectedTaskToView = action.payload;
    },
    setViewTask: (state, action) => {
      state.viewTask = action.payload;
    },
    setShowBreakTaskModal: (state, action) => {
      state.showBreakTaskModal = action.payload
    },
    setBreakTaskEmployee: (state, action) => {
      state.breakTaskEmployee = action.payload
    },
    setSelectedBreakTask: (state, action) => {
      state.selectedBreakTask = action.payload
    },
    resetBreakTaskFlags: (state) => {
      state.showBreakTaskModal = false;
      state.breakTaskEmployee = null;
      state.selectedBreakTask = null;
    },
    setShowAdhocTaskModal: (state, action) => {
      state.showAdhocTaskModal = action.payload;
    },
    setAdhocTaskEmployee: (state, action) => {
      state.adhocTaskEmployee = action.payload;
    },
    setSelectedAdhocTask: (state, action) => {
      state.selectedAdhocTask = action.payload;
    },
    resetAdhocTaskFlags: (state) => {
      state.showAdhocTaskModal = false;
      state.adhocTaskEmployee = null;
      state.selectedAdhocTask = null;
    },
    setSelectedFlightToView: (state, action) => {
      state.selectedFlightToView = action.payload
    },

    setSelectedMultiplePAXTask: (state, action) => {
      state.selectedMultiplePAXTask = action.payload
    },
    setSelectedMultiplePAXTaskError: (state, action) => {
      state.selectedMultiplePAXTaskError = action.payload
    },
    setShowEditTaskModal: (state, action) => {
      state.showEditTaskModal = action.payload
    },
    setEditModalType: (state, action) => {
      state.editModalType = action.payload
    },

  },
  extraReducers: {},
});

export const {
  reset,
  resetSelectedTasksList,
  setSelectedTask,
  setShowConfirmationModal,
  setSelectedTaskList,
  setSelectedTaskToView,
  setViewTask,
  setShowBreakTaskModal,
  setBreakTaskEmployee,
  setSelectedBreakTask,
  resetBreakTaskFlags,
  setShowAdhocTaskModal,
  setAdhocTaskEmployee,
  setSelectedAdhocTask,
  resetAdhocTaskFlags,
  setSelectedFlightToView,
  setSelectedMultiplePAXTask,
  setSelectedMultiplePAXTaskError,
  setShowEditTaskModal,
  setEditModalType
} = selectedTaskSlice.actions;
// Base selector
const selectSelectedTaskState = (state) => state.selectedTask;

// OPTIMIZED: Memoized selectors
export const selectSelectedTask = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.selectedTask
);

export const selectShowConfirmationModal = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.showConfirmationModal
);

export const selectSelectedTasksList = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.selectedTasksList
);

export const selectSelectedTasksListIds = createSelector(
  [selectSelectedTasksList],
  (selectedTasksList) => {
    if (Array.isFullArray(selectedTasksList)) {
      return selectedTasksList.map((task) => task?._id);
    } else {
      return [];
    }
  }
);

export const selectSelectedTaskToView = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.selectedTaskToView
);

export const selectViewTask = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.viewTask
);

export const selectShowBreakTaskModal = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.showBreakTaskModal
);

export const selectBreakTaskEmployee = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.breakTaskEmployee
);

export const selectSelectedBreakTask = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.selectedBreakTask
);

export const selectShowAdhocTaskModal = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.showAdhocTaskModal
);

export const selectAdhocTaskEmployee = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.adhocTaskEmployee
);

export const selectSelectedAdhocTask = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.selectedAdhocTask
);

export const selectSelectedFlightToView = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.selectedFlightToView
);

export const selectSelectedMultiplePAXTask = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.selectedMultiplePAXTask
);

export const selectSelectedMultiplePAXTaskError = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.selectedMultiplePAXTaskError
);

export const selectEditModalType = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.editModalType
);

export const selectShowEditModal = createSelector(
  [selectSelectedTaskState],
  (selectedTaskState) => selectedTaskState.showEditTaskModal
);
export default selectedTaskSlice.reducer;
